// Telegram Backend servisi
class TelegramService {
  constructor() {
    const isProduction = window.location.hostname !== 'localhost';
    this.backendURL = isProduction ? '/api' : 'http://localhost:3001';
  }

  async sendMessage(chatId, message) {
    try {
      const endpoint = this.backendURL.includes('localhost') 
        ? `${this.backendURL}/api/send-message`
        : `${this.backendURL}/telegram-send`;
      
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ chatId, message })
      });

      const data = await response.json();
      return { success: data.success, data };
    } catch (error) {
      console.error('Telegram mesaj gönderme hatası:', error);
      return { success: false, error: error.message };
    }
  }

  async sendBulkMessages(messages, students = []) {
    try {
      const endpoint = this.backendURL.includes('localhost')
        ? `${this.backendURL}/api/send-bulk-messages`
        : `${this.backendURL}/telegram-bulk`;
      
      const response = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages })
      });

      const data = await response.json();
      return data.results.map((result, index) => ({
        ...result,
        studentName: messages[index].studentName,
        parentName: messages[index].parentName
      }));
    } catch (error) {
      console.error('Toplu mesaj gönderme hatası:', error);
      return [];
    }
  }
}

export const telegramService = new TelegramService();

// KV entegrasyonu için yardımcı fonksiyonlar
export const telegramUtils = {
  // Chat ID'si olan öğrencileri filtrele
  getStudentsWithTelegram(students) {
    return students.filter(student => 
      student.parentTelegram && 
      student.parentTelegram !== '@kullanici_adi' &&
      !student.parentTelegram.startsWith('@')
    );
  },
  
  // Chat ID formatını kontrol et
  isValidChatId(chatId) {
    return chatId && 
           typeof chatId === 'string' && 
           !chatId.startsWith('@') && 
           (chatId.match(/^-?\d+$/) || chatId.length > 5);
  }
};